import { useEffect, useRef } from 'react';

export default function Snowfall({ count = 80, speed = 1 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let w, h, raf;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const flakes = Array.from({ length: count }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 2.8 + 1.2,
      d: Math.random() * 0.8 + 0.4,
      drift: Math.random() * Math.PI * 2,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      // Azul hielo con borde fino: se ve sobre fondo claro
      ctx.fillStyle = 'rgba(214, 232, 250, 0.95)';
      ctx.strokeStyle = 'rgba(120, 156, 190, 0.45)';
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      flakes.forEach((f) => {
        ctx.moveTo(f.x + f.r, f.y);
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      });
      ctx.fill();
      ctx.stroke();

      flakes.forEach((f) => {
        f.drift += 0.01;
        f.y += (f.d + f.r * 0.3) * speed;
        f.x += Math.sin(f.drift) * 0.5;
        if (f.y > h + 5) { f.y = -5; f.x = Math.random() * w; }
        if (f.x > w + 5) f.x = -5;
        if (f.x < -5) f.x = w + 5;
      });
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, [count, speed]);

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 50,
      }}
    />
  );
}